import styled from 'styled-components';
import { sizes } from '../../theme/modules/sizes';

export const Header = styled.header`
  padding-top: ${sizes.md};
  padding-right: ${sizes.md};
  padding-left: ${sizes.md};
  margin-bottom: ${sizes.md};

  & > * + * {
    margin-top: ${sizes.xs};
  }
`;

export const HeaderGrid = styled.div`
  /* display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
  grid-auto-columns: max-content;
  column-gap: ${sizes.base};
  align-items: center; */

  display: flex;
  justify-content: flex-end;
  align-items: center;

  & > *:first-child {
    flex: 1;
  }
`;
